import { Group, Text } from "@mantine/core";
import { Link } from "@remix-run/react";

import LaRucheLogo from "~/assets/misc/logo-icon.svg?react";

import classes from "./footer.module.scss";

export const Footer = () => {
  // const { t } = useTranslation();

  return (
    <footer className={classes.footer}>
      {/* <div className="footer-content">
        <p>
          <span>{t("support")}:</span>&nbsp;+225 05 02 87 68 87 •&nbsp;
          <Link to="mailto:engineering@laruche.health">
            engineering@laruche.health
          </Link>
        </p>
        <p>
          <span>©️ {new Date().getFullYear()}</span>
          <LaRucheLogo />
          <span>La Ruche Health {t("all-rights-reserved")}</span>
        </p>
      </div> */}
      <div className={classes["footer-content"]}>
        <Group gap={"xs"} justify="space-between">
          <Group gap={5}>
            <Text fz={13}>Support:&nbsp;+225 05 02 87 68 87</Text>•
            <Link to="mailto:engineering@laruche.health">
              engineering@laruche.health
            </Link>
          </Group>

          <Group gap={5} fz={13}>
            <Text span fz={"inherit"}>
              ©️ {new Date().getFullYear()}
            </Text>
            <Group gap={5}>
              <LaRucheLogo width={15} />
              La Ruche Health
            </Group>
            <Text span fz={"inherit"}>
              All rights reserved.
            </Text>
          </Group>
        </Group>
      </div>
    </footer>
  );
};
